// ABOUTME: Export/Import actions for the global catalog metadata editor (button pair + import dialog).
import {Button} from '@hm/fundamental'
import React, {useState} from 'react'

import {CatalogBundleImportDialog} from './CatalogBundleImportDialog'
import {
  useExportGlobalConfig,
  useImportGlobalConfig,
  useValidateGlobalImport
} from '../hooks/useCatalogImportExport'

export const GlobalImportExportActions: React.FC = () => {
  const exportGlobal = useExportGlobalConfig()
  const validateGlobal = useValidateGlobalImport()
  const importGlobal = useImportGlobalConfig()
  const [importOpen, setImportOpen] = useState(false)

  return (
    <>
      <Button variant="secondary" onClick={() => exportGlobal.mutate()} disabled={exportGlobal.isPending}>
        Export
      </Button>
      <Button variant="secondary" onClick={() => setImportOpen(true)}>
        Import
      </Button>
      <CatalogBundleImportDialog
        open={importOpen}
        onClose={() => setImportOpen(false)}
        title="Import global metadata"
        busy={validateGlobal.isPending || importGlobal.isPending}
        onValidate={(bundle) => validateGlobal.mutateAsync(bundle)}
        onImport={(args) => importGlobal.mutateAsync(args)}
      />
    </>
  )
}
